import React from "react";
import styles from "./alert.module.css";
import { MdErrorOutline } from "react-icons/md";

function Alert({ children, type }) {
  switch (type) {
    case "error":
      return (
        <div className={styles.alertContainer}>
          <div className={`${styles.alert} ${styles.error}`}>
            <p className={styles.alertContent}><MdErrorOutline className={styles.errorIcon} size={18}/>{children}</p>
          </div>
        </div>
      );
    case "success":
      return (
        <div className={styles.alertContainer}>
          <div className={`${styles.alert} ${styles.success}`}>
            <p className={styles.alertContent}>{children}</p>
          </div>
        </div>
      );
    default:
      return (
        <div className={styles.alertContainer}>
          <div className={`${styles.alert} ${styles.error}`}>
            <p className={styles.alertContent}>{children}</p>
          </div>
        </div>
      );
  }
}

export default Alert;